import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectLoginDomain = (state) => state.get("login", initialState)

export const makeSelectError = () =>
  createSelector(selectLoginDomain, (loginState) => loginState.get("error"))

export const makeSelectErrorExceed = () =>
  createSelector(selectLoginDomain, (loginState) =>
    loginState.get("errorExceed")
  )

export const makeSelectErrorMessage = () =>
  createSelector(selectLoginDomain, (loginState) =>
    loginState.get("errorMessage")
  )

export const makeSelectLoading = () =>
  createSelector(selectLoginDomain, (loginState) => loginState.get("isLoading"))

const makeSelectLogin = () =>
  createSelector(selectLoginDomain, (substate) => substate.toJS())

export default makeSelectLogin
export { selectLoginDomain }
